import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [callbackPhone, setCallbackPhone] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleCallbackSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!callbackPhone.trim()) return;

    // Send to WhatsApp or register callback
    const message = encodeURIComponent(`Hi ASW Cars, please arrange a callback for vehicle quotation on my number: ${callbackPhone}`);
    window.open(`https://wa.me/919987828417?text=${message}`, '_blank');
    setIsSubmitted(true);
    setTimeout(() => {
      setCallbackPhone('');
      setIsSubmitted(false);
    }, 4000);
  };

  return (
    <footer className="asw-footer" id="footer">
      {/* Top Accent Gradient Border */}
      <div className="asw-footer-glow-bar"></div>

      <div className="asw-footer-container">
        <div className="asw-footer-grid">
          {/* Column 1: Brand Info & Address */}
          <div className="asw-footer-col brand-col">
            <div className="asw-footer-logo-wrap">
              <Link to="/" className="asw-footer-logo-link">
                <img 
                  src="/Website-Images/Logo/logo.jpg" 
                  alt="ASW Cars" 
                  className="asw-footer-logo-img"
                />
              </Link>
            </div>
            
            <p className="asw-footer-desc">
              Maharashtra’s trusted commercial T-Permit and private passenger car dealership. Offering 100% on-road funding, lowest interest rates, and express vehicle delivery.
            </p>

            <div className="asw-footer-location">
              <div className="asw-loc-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div className="asw-loc-text">
                <strong>Main Showroom & Head Office:</strong>
                <span>GB 60, Ground Floor, High Street Mall, Kapurbawdi, Thane West, Thane - 400607</span>
              </div>
            </div>

            <div className="asw-footer-socials">
              <a href="https://wa.me/919987828417" target="_blank" rel="noopener noreferrer" className="asw-social-icon whatsapp" title="Chat on WhatsApp">
                <i className="fa-brands fa-whatsapp"></i>
              </a>
              <a href="tel:+919987828690" className="asw-social-icon call" title="Call Showroom">
                <i className="fa-solid fa-phone"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="asw-social-icon facebook" title="Facebook">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="asw-social-icon instagram" title="Instagram">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Popular Models */}
          <div className="asw-footer-col">
            <h3 className="asw-footer-heading">Popular Vehicles</h3>
            <ul className="asw-footer-links">
              <li>
                <Link to="/car/maruti-suzuki-wagon-r">Maruti Suzuki Wagon-R CNG</Link>
              </li>
              <li>
                <Link to="/car/maruti-suzuki-ertiga">Maruti Suzuki ERTIGA CNG</Link>
              </li>
              <li>
                <Link to="/car/toyota-rumion">Toyota Rumion 7-Seater CNG</Link>
              </li>
              <li>
                <Link to="/car/hyundai-aura">Hyundai Aura Sedan CNG</Link>
              </li>
              <li>
                <Link to="/car/maruti-suzuki-dzire">Maruti Suzuki Dzire Tour S</Link>
              </li>
              <li>
                <Link to="/car/toyota-innova-crysta">Toyota Innova Crysta</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Services */}
          <div className="asw-footer-col">
            <h3 className="asw-footer-heading">Services & Finance</h3>
            <ul className="asw-footer-links">
              <li>
                <Link to="/finance-offers">SBI & Bank Loan Offers</Link>
              </li>
              <li>
                <Link to="/new-cars">All New Cars Catalog</Link>
              </li>
              <li>
                <Link to="/business-loan">Business Loans & Funding</Link>
              </li>
              <li>
                <Link to="/blogs">Car Guides & RTO Tips</Link>
              </li>
              <li>
                <Link to="/about-us">About ASW Dealership</Link>
              </li>
              <li>
                <Link to="/crm" className="asw-crm-link">
                  <span className="asw-crm-dot"></span> Staff CRM Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact & Quick Callback */}
          <div className="asw-footer-col contact-col">
            <h3 className="asw-footer-heading">Helpline & Support</h3>
            
            <div className="asw-contact-list">
              <a href="tel:+919987828690" className="asw-contact-item">
                <div className="asw-contact-icon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div>
                  <div className="contact-label">Customer Support</div>
                  <div className="contact-val">+91 99878 28690</div>
                </div>
              </a>

              <a href="https://wa.me/919987828417" target="_blank" rel="noopener noreferrer" className="asw-contact-item">
                <div className="asw-contact-icon whatsapp">
                  <i className="fa-brands fa-whatsapp"></i>
                </div>
                <div>
                  <div className="contact-label">WhatsApp Helpline</div>
                  <div className="contact-val">+91 99878 28417</div>
                </div>
              </a>

              <div className="asw-advisors-box">
                <div className="advisors-label">Vehicle Finance Advisors:</div>
                <div className="advisors-numbers">
                  <a href="tel:+919987798417">Pintu: +91 99877 98417</a>
                  <a href="tel:+919004726521">Prakash: +91 90047 26521</a>
                </div>
              </div>

              <div className="asw-contact-item email-item">
                <div className="asw-contact-icon">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div>
                  <div className="contact-label">Official Email</div>
                  <div className="contact-val">asw.cars@gmail.com</div>
                </div>
              </div>
            </div>

            {/* Quick Callback Widget */}
            <div className="asw-quick-callback">
              <div className="quick-callback-title">Request Instant Callback</div>
              {isSubmitted ? (
                <div className="callback-success">
                  ✓ Callback request sent on WhatsApp!
                </div>
              ) : (
                <form onSubmit={handleCallbackSubmit} className="callback-form">
                  <input 
                    type="tel" 
                    placeholder="Enter WhatsApp / Mobile Number" 
                    value={callbackPhone}
                    onChange={(e) => setCallbackPhone(e.target.value)}
                    required
                  />
                  <button type="submit" title="Send Request">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* Footer Bottom Bar */}
        <div className="asw-footer-bottom">
          <div className="asw-footer-copy">
            &copy; {currentYear} <strong>ASW Auto (ASW Cars)</strong>. All rights reserved. 
            Commercial Tourist T-Permit & Private Passenger Vehicle Solutions.
          </div>
          <div className="asw-footer-bottom-links">
            <Link to="/about-us">About</Link>
            <span>•</span>
            <Link to="/finance-offers">Finance</Link>
            <span>•</span>
            <Link to="/blogs">Blogs</Link>
            <span>•</span>
            <a href="https://wa.me/919987828417" target="_blank" rel="noopener noreferrer">Support</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;